module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class='bcForm FormBreadcrumb' id=\"FormBreadcrumb\">App</div>\r\n<div class='bcForm ReportBreadcrumb' id=\"ReportBreadcrumb\">Report</div>\r\n<div class='bcForm WorkflowBreadcrumb' id=\"WorkflowBreadcrumb\">Workflow</div>\r\n<div class='bcForm BehaviorBreadcrumb' id=\"BehaviorBreadcrumb\">Behavior</div>\r\n<div class='bcPage hide'> &gt Page</div>\r\n\r\n<div class='bcSection hide'> &gt Section</div>\r\n\r\n<div class='bcObject hide'> &gt Object</div>\r\n\r\n<div class='bcBehavior hide'> &gt Behavior</div>\r\n\r\n")
  }
  return __output;

}